import React from 'react';
import { useLexicon } from '../../hooks/useLexicon';
import {
  MainContainer,
  Section,
  Title,
  Pages,
  Page,
  PageName,
  PageIcon,
  InfoParagraph
} from './startOnboardingStyle';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { welcomeOnboardingPages } from './onboardingContents';

const StartOnboarding = ({ onCloseOnboarding }) => {
  const { lt } = useLexicon();
  const history = useHistory();

  return (
    <MainContainer>
      <Section style={{ height: '385px' }}>
        <Title>New</Title>
        <Pages>
          {welcomeOnboardingPages.map((page) => (
            <Page
              onClick={() => {
                history.push(page.link), onCloseOnboarding();
              }}
            >
              <PageIcon src={page.icon} />
              <PageName>{lt(page.name)}</PageName>
            </Page>
          ))}
        </Pages>

        <InfoParagraph>
          <p>
            <strong>We’ve made a change!</strong>
          </p>
          <p>
            On the 'Tasks' page, the 'Completed Tasks' tab is now called 'Closed
            Tasks'.
          </p>
          <p>
            Previously, tasks were automatically moved to the 'Completed Tasks'
            at the due time.</p> 
           <p> Now, any assigned tasks will remain as 'Current
            Tasks' until you manually close them using the three dots on the
            task bubble.
          </p>
          <p>Once a task is closed:</p>
          <ul>
            <li>All submissions are locked (no further edits or feedback).</li>
            <li>
              You can 'Reopen' a task anytime from the 'Closed Tasks' page.
            </li>
          </ul>
        </InfoParagraph>
      </Section>
    </MainContainer>
  );
};

export default StartOnboarding;
